import { Link } from "react-router-dom";
import styled from "styled-components";

export const RoundedButton = styled(Link)<{ $secondary?: boolean }>`
    font-family: var(--font-primary);
    font-size: var(--size-smaller);
    border-radius: 500px;
    padding: 14px 32px;
    color: ${(p) => (!p.$secondary ? "#fff" : "var(--color-primary-dark)")};
    background-color: ${(p) => (!p.$secondary ? "var(--color-primary)" : "transparent")};
    border: ${(p) => (!p.$secondary ? "unset" : "1px solid var(--color-primary-dark)")};
    font-weight: 300;
    transition: all .25s;
    display: inline-block;

    &&:hover
    {
        border-color: ${(p) => (!p.$secondary ? "unset" : "var(--color-primary)")};
        background-color: ${(p) => (!p.$secondary ? "var(--color-primary-dark)" : "initial")};
        color: ${(p) => (!p.$secondary ? "#fff" : "var(--color-primary)")};
        opacity: 1;
    }
`;
